// extracted by mini-css-extract-plugin
module.exports =  {"main":"b429494557--main--Nn8yO"};